import styled from 'styled-components';

export const InlineTextEditorSpan = styled.span`
display: flex;
flex-direction: row;
align-items: center;

> :not(:last-child) {
  margin-right: .75em;
}
`;

const PillRowBorderRadius = '10px';
export const PillRow = styled.span`
&&& { /* increase specificity to override global modal styles :( */
display: flex;
flex-direction: row;
align-items: center;

> * {
  margin: 0;
  padding: 5px;
  border: 1px solid gray;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    flex: 1 1 100%;
  }

  &:first-child {
    border-top-left-radius: ${PillRowBorderRadius};
    border-bottom-left-radius: ${PillRowBorderRadius};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  &:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: ${PillRowBorderRadius};
    border-bottom-right-radius: ${PillRowBorderRadius};
  }
  &:not(:last-child) {
    border-right: none;
  }
}

input {
  height: 32px;
  width: 120px;
  padding-left: .75em;
}
:not(input) {
  cursor: pointer;
}
}
`;

export const ErrorText = styled.span`
color: red;
`;
